import { useCallback, useState } from 'react';

import {
	revokeCancellation,
	SubscriptionActionTypes,
	useBusinessLayer,
	useDTicketSubscription,
} from '@mopla/business-logic';

import { usePassengerAppNavigate } from '../../../../hooks';

export const useDTicketSubscriptionRevoke = () => {
	const { navigateToUserDTicket } = usePassengerAppNavigate();
	const bl = useBusinessLayer();
	const { subscription } = useDTicketSubscription();

	const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
	const [isRevokeLoading, setIsRevokeLoading] = useState(false);

	const handleRevoke = useCallback(() => {
		if (!subscription?.id) return;

		setIsRevokeLoading(true);

		bl.dispatch(
			revokeCancellation({
				subscriptionId: subscription.id,
			})
		);

		bl.watchActions({
			types: SubscriptionActionTypes.RevokeCancellationResult,
			callback: (action) => {
				setIsRevokeLoading(false);

				if (action.payload?.error) {
					console.error('Error revoking cancellation:', action.payload.error);
				} else {
					setIsSuccessModalOpen(true);
				}
			},
		});
	}, [subscription?.id, bl]);

	const closeSuccessModal = useCallback(() => {
		setIsSuccessModalOpen(false);
		navigateToUserDTicket();
	}, [navigateToUserDTicket]);

	return {
		isRevokeLoading,
		isSuccessModalOpen,
		handleRevoke,
		closeSuccessModal,
	};
};
